module.exports = __webpack_public_path__ + "img/btn_left@3x.97126581.png";